import React from "react";
import { Box, Typography, Card, CardContent, Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SecretMessageBlog = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language || 'en';
    
    return (
        <Box sx={{ mt: { xs: 4, sm: 6 }, px: { xs: 2, sm: 4 }, mb: { xs: 4, sm: 8 } }}>
            <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{ textAlign: "center", mb: 4, fontSize: { xs: "1.6rem", sm: "2rem", md: "2.4rem" } }}
            >
                {t('blog.pageTitle')}
            </Typography>
            <Grid container spacing={4}>
                {t('blog.posts', { returnObjects: true }).map((post, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Card
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                boxShadow: 3,
                                borderRadius: 2,
                                p: 2,
                                "&:hover": {
                                    boxShadow: 6,
                                    transform: "translateY(-4px)",
                                    transition: "all 0.3s ease"
                                }
                            }}
                        >
                            <CardContent>
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    gutterBottom
                                    sx={{ fontSize: { xs: "1rem", sm: "1.2rem", md: "1.3rem" } }}
                                >
                                    {post.title}
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    {post.excerpt}
                                </Typography>
                            </CardContent>
                            <Button
                                component={Link}
                                to={`/${currentLang}`}
                                variant="contained"
                                size="small"
                                sx={{ mt: "auto", fontSize: { xs: "0.8rem", sm: "0.9rem" }, fontWeight: "bold" }}
                            >
                                {post.cta}
                            </Button>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SecretMessageBlog;
